import React, { useState } from 'react';
import { Loading, Modal } from '@carbon/react';

// This is a modal to inform the user about something and ask for confirmation
// The user can either confirm or cancel the action
// the Next callback is called when the user confirms the action
const ConfirmSomethingModal = ({title, message, next, hideModal }) => {
  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Löschen"
      secondaryButtonText="Abbrechen"
      modalHeading={title}
      onRequestClose={hideModal}
      onRequestSubmit={() => {
        next();
        hideModal();
      }}
    >
      {message || "Möchten Sie das wirklich tun?"}
    </Modal>
  )
}

export default ConfirmSomethingModal;
